import {Component, OnDestroy, OnInit, Output} from '@angular/core';
import {LoginService} from '../../login/login.service';
import {LoginEvent} from '../../../model/login-event';

@Component({
  selector: 'pbc-functional-menu',
  templateUrl: './functional-menu.component.html',
  styleUrls: ['./functional-menu.component.css']
})
export class FunctionalMenuComponent implements OnInit, OnDestroy {

  constructor(private loginService: LoginService) { }
  private userRoleAdmin: boolean = false;
  private userLogged: boolean = false;

  @Output() showToCurrentUser: boolean = true;

  ngOnInit() {
    this.loginService.loginEvent.subscribe(
      (loginEvent: LoginEvent) => {
        this.userLogged = loginEvent.isUserLogged;
        if (this.userLogged) {
          this.showToCurrentUser = true;
        }
      }
    );
  }

  ngOnDestroy() {
    this.loginService.loginEvent.unsubscribe();
  }
}
